export default __webpack_public_path__ + "static/media/Roboto-Medium.cb91c08a.ttf";